import { useMemo } from 'react'

import { getRetailMediaAccountType } from '~/helpers'

import { metricsOptionsSelect as metricsOptionsSelectRaw } from './selectOptions'

export function useChart({
  isRealtime,
  adType,
  selectedMetrics,
  selectQuantity,
  excludeMetrics
}: UseChartProps) {
  const accountType = getRetailMediaAccountType()
  const metricsByAccountType = isRealtime
    ? metricsOptionsSelectRaw.publisherRealtime
    : metricsOptionsSelectRaw?.[accountType]

  const metricsByAdType: Record<CampaignAdType, MetricsByAdType> = {
    product: { type: 'all' },
    sponsored_brand: { type: 'all' },
    banner: { type: 'all' },
    banner_video: { type: 'all' },
    sponsored_brand_video: { type: 'all' },
    digital_signage: {
      type: 'subset',
      cards: ['impressions']
    },
    banner_off_site: {
      type: 'all'
    }
  }

  const metricsOptionsSelect = useMemo(() => {
    const isSubset =
      adType &&
      metricsByAdType[adType] &&
      metricsByAdType[adType].type === 'subset'

    const subsetCards = isSubset
      ? (metricsByAdType[adType].cards as AvailablePresets[])
      : null

    const bySubset = subsetCards
      ? metricsByAccountType.filter(item => subsetCards.includes(item.value))
      : metricsByAccountType

    if (!excludeMetrics?.length) return bySubset

    return bySubset.filter(item => !excludeMetrics.includes(item.value))
  }, [adType, metricsByAdType, metricsByAccountType, excludeMetrics])

  const getMetricsOptionsByIndex = useMemo(() => {
    const options = metricsOptionsSelect.map(item => ({
      ...item,
      isDisabled: Object.values(selectedMetrics).indexOf(item.value) > -1
    }))

    const getDefaultValue = (index: number) => {
      const selectedKey = selectedMetrics?.[index]

      const foundItem = () =>
        metricsOptionsSelect.find(item => item.value === selectedMetrics[index])

      return !selectedKey ? null : foundItem()
    }

    const data = (index: number) => ({
      defaultValue: getDefaultValue(index),
      options
    })

    const response = Array.from({ length: selectQuantity }).map((_, index) =>
      data(index)
    )

    return response
  }, [metricsOptionsSelect, selectQuantity, selectedMetrics])

  return {
    getMetricsOptionsByIndex
  }
}
